import { useMemo } from "react";

import { useApiQuery } from "app/modules/api-client";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useCommonAlertsQueryParams } from "../../useCommonAlertsQueryParams";
import { useNewsAlertsFilterStore } from "../filters/useNewsAlertsFilterStore";
import { transformVolumeOverTimeData } from "../utils/transformVolumeOverTimeData";

export const useNewsVolumeOverTimeData = () => {
    const selectedTopics = useNewsAlertsFilterStore((s) => s.selectedTopics);
    const isDefaultTopicsSelected = useNewsAlertsFilterStore((s) => s.isDefaultTopicsSelected);
    const params = useCommonAlertsQueryParams();
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();

    const topics = useMemo(
        () => (isDefaultTopicsSelected ? undefined : Array.from(selectedTopics.keys())),
        [isDefaultTopicsSelected, selectedTopics],
    );

    const {
        data,
        isLoading: isDataLoading,
        isError,
    } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsMetricsNewsVolumeOverTimeDetail",
            options: {
                refetchOnMount: true,
            },
        },
        {
            ...params,
            topics,
        },
    );

    const transformedData = useMemo(() => {
        if (!data) {
            return [];
        }

        return transformVolumeOverTimeData({
            data: data.data,
            primaryDomain: activationSet?.primaryDomain,
        });
    }, [activationSet?.primaryDomain, data]);

    return {
        data: transformedData,
        primaryDomain: activationSet?.primaryDomain,
        isError,
        isLoading: isActivationSetLoading || isDataLoading,
        isMonthly: data?.grouping === "Monthly",
    };
};
